import React from 'react'
import doctor from '../img/ABOUT.jpg'
import { Link } from 'react-router-dom'


const About = () => {
    return (


<div className='section'>

        <div className='about'>

            <div className='about2'>
                <img src={doctor} />
            </div>

            <div className='about2'>
                <h1 >Meet Our Doctor</h1>

                <p>Dr. Manish Khattar is an outstanding urologist with an immaculate background in medical education and clinical practice. He completed his MBBS, MS in General Surgery, and MCh in Urology from the prestigious All India Institute of Medical Sciences (AIIMS), Delhi during his stint of 13 years at the institute.</p>

                <p>His passion for urology led him to pursue specialized training, and he was honored with the Dr. JR Chawla Gold Medal for the best Senior Resident in Urology, recognizing his excellence in patient care and academic achievements.</p>

                <p>With a strong foundation in both general surgery and urology, Dr. Manish Khattar is dedicated to providing personalized, evidence-based care to his patients. His clinical interests include uro-oncology, endourology, and men’s health initiatives. Dr. Khattar is committed to staying at the forefront of medical advancements, ensuring that his patients receive the highest standard of care.</p>


                <Link to='/' className='btn btn-primary'> Read More </Link>

            </div>

        </div>
        </div>
    )
}

export default About